module.exports = __webpack_public_path__ + "img/help-desk-analyst.1f5ad7df.png";